import { create } from "zustand";

interface DataType {
  dashboardName: string;
  setDashboardName: (val: string) => void;
}
export const useDashboardName = create<DataType>((set) => ({
  dashboardName: "",
  setDashboardName: (val) => set({ dashboardName: val }),
}));
